import { io } from "socket.io-client";

// ประกาศการเชื่อมต่อ socket ครั้งเดียว
const socket = io("https://api.24xbet.co/");

export default socket;
